<template>
  <v-container>
    <ValidationObserver ref="objects" v-slot="{ invalid }">
      <v-form>
        <v-row>
          <v-col cols="12">
            <ValidationProvider name="State">
              <v-select
                v-model="selectedState"
                :items="states"
                item-value="id"
                item-text="title"
                :menu-props="{ maxHeight: '200' }"
                label="Select state (optional)"
                clearable
                hint="Pick a state (optional)"
                persistent-hint
                :error-messages="errors"
                slot-scope="{ errors }"
              ></v-select>
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Staff Status">
              <v-select
                v-model="selectedStaffStatus"
                :items="staffStatuses"
                item-value="id"
                item-text="title"
                :menu-props="{ maxHeight: '200' }"
                label="Select staff status (optional)"
                clearable
                hint="Pick a staff status (optional)"
                persistent-hint
                :error-messages="errors"
                slot-scope="{ errors }"
              ></v-select>
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Type">
              <v-select
                v-model="defaultFileType"
                :items="allowedFileTypes"
                :menu-props="{ maxHeight: '400' }"
                label="Type"
                auto-select-first
                flat
              ></v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="justify-end">
            <v-btn class="primary" @click="okAction()" :disabled="invalid">Export</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import store from '@/store/index';

export default {
  name: 'StaffPostalByStateDialog',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    reportFilenamePrefix: {
      type: String,
      default: 'Staff Postal Address by State'
    },
    reportName: {
      type: String,
      default: 'staff-postal-report'
    },
    allowedFileTypes: {
      type: Array,
      default: () => ['html']
    },
    defaultFileType: {
      type: String,
      default: 'html'
    }
  },
  data: () => ({
    selectedState: null,
    selectedStaffStatus: null
  }),
  computed: {
    ...mapGetters('state', ['states']),
    ...mapGetters('staffStatus', ['staffStatuses'])
  },
  mounted() {
    store.dispatch('state/getStatesByCountry', 'au');
    store.dispatch('staffStatus/getStaffStatuses');
  },
  methods: {
    filename() {
      let filename = this.reportFilenamePrefix;
      if (this.selectedState) filename += '-' + this.selectedState;
      if (this.selectedStaffStatus) filename += '-' + this.selectedStaffStatus;
      return filename.replace(/[^a-z0-9]/gi, '-') + '.' + this.defaultFileType;
    },
    okAction() {
      let url = `${process.env.VUE_APP_API_URL}/export/staff-postal-report`;
      const params = [];
      if (this.selectedStaffStatus) params.push(`staff_statuses_id=${this.selectedStaffStatus}`);
      if (this.selectedState) params.push(`state_id=${this.selectedState}`);
      if (params.length > 0) url += '?' + params.join('&');
      window.open(url, '_blank').focus();
    }
  }
};
</script>
